import React from 'react';

import { Background, BannerContent, BannerSection } from './BannerStyles';

import TitleSection from 'src/components/TitleSection';
import { Colors } from 'src/styles/DesignSystem';


const GeneralBanner = ({
    wd, bgImage, title
}) => {
    return (
        <BannerSection>
            <Background src={bgImage} alt="  " />
            <BannerContent wd={wd}>
                <TitleSection textColor={Colors.white}>{title}</TitleSection>
            </BannerContent>
        </BannerSection>
    )
}

export default GeneralBanner;